import { render } from "./Services2.vue?vue&type=template&id=8379b02a&scoped=true"
import script from "./Services2.vue?vue&type=script&lang=js"
export * from "./Services2.vue?vue&type=script&lang=js"

import "./Services2.vue?vue&type=style&index=0&id=8379b02a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8379b02a"]])

export default __exports__